import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroComponent } from './hero/hero.component';
import { CategoriesSliderComponent } from './categories-slider/categories-slider.component';
import { UseCasesComponent } from './use-cases/use-cases.component';
import { CallToActionComponent } from './call-to-action/call-to-action.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    HeroComponent,
    CategoriesSliderComponent,
    UseCasesComponent,
    CallToActionComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  @Input() appUrl = '/postcards/create';
}
